export const articles = [
  {
    id: 'article-1',
    title: '英超新赛季前瞻：六大豪门阵容深度对比，谁能笑到最后？',
    slug: 'premier-league-season-preview-2026',
    category: 'football',
    author: '张伟',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20sports%20journalist%20portrait%20in%20clean%20studio%20lighting%20with%20neutral%20gray%20background%2C%20editorial%20style%2C%20warm%20professional%20look%2C%20Asian%20male%20in%20casual%20blazer&width=100&height=100&seq=avatar-zhangwei&orientation=squarish',
    date: '2026-08-07',
    readTime: '8分钟',
    views: 28650,
    image: 'https://readdy.ai/api/search-image?query=Professional%20football%20soccer%20stadium%20atmosphere%20with%20dramatic%20evening%20lighting%2C%20green%20pitch%20with%20players%20in%20action%2C%20packed%20stadium%20crowd%2C%20sports%20photography%20style%2C%20cinematic%20composition%2C%20warm%20golden%20hour%20tones&width=800&height=450&seq=article-football-1&orientation=landscape',
    excerpt: '随着2026-2027赛季英超联赛即将拉开帷幕，六大豪门在转会市场上的操作各有千秋。本文将从阵容深度、战术体系和关键球员三个维度，深度剖析各队新赛季的竞争格局。',
    content: `
      <p>随着2026-2027赛季英超联赛即将拉开帷幕，六大豪门在转会市场上的操作各有千秋，新赛季的争冠格局变得更加扑朔迷离。本文将从阵容深度、战术体系和关键球员三个维度，深度剖析各队新赛季的竞争格局。</p>
      
      <h3>曼城：卫冕冠军的稳定性</h3>
      <p>作为上赛季的英超冠军，曼城在保留核心阵容的基础上，针对性地补强了中场和后防线。瓜迪奥拉的战术体系已经非常成熟，球队在控球和压迫方面的表现依然是联赛顶级。新引进的年轻中场为球队注入了新鲜血液，使得阵容轮换更加从容。</p>
      <p>然而，随着核心球员年龄的增长，曼城需要在密集赛程中更好地管理体能。欧冠与联赛的双线作战将是对球队阵容深度的最大考验。</p>
      
      <h3>阿森纳：青春风暴再升级</h3>
      <p>阿森纳在阿尔特塔的带领下持续进步，上赛季距离冠军仅一步之差。新赛季球队在锋线和中场都进行了针对性补强，阵容厚度较前几个赛季有了质的飞跃。年轻球员的成长加上经验丰富的新援，让枪手的整体实力更加均衡。</p>
      
      <h3>利物浦：新帅新气象</h3>
      <p>利物浦在经历换帅后，新赛季展现出全新的战术面貌。高位压迫依旧是球队的标志性打法，但在进攻组织上有了更多变化。新援的融入速度将直接影响球队的开局表现。</p>
      
      <h3>切尔西：重建之路的曙光</h3>
      <p>切尔西在上赛季后半段展现出复苏迹象，新赛季球队阵容趋于稳定。年轻球员得到了充分的锻炼机会，新赛季有望在联赛中扮演搅局者的角色。中场的创造力是球队最大的武器。</p>
      
      <h3>曼联：期待重回巅峰</h3>
      <p>曼联在新赛季进行了大规模阵容调整，多名实力派球员加盟。球队的进攻火力得到了显著提升，但防守端的稳定性仍需通过比赛来验证。欧战资格的争夺将是球队的底线目标。</p>
      
      <h3>热刺：稳中求进</h3>
      <p>热刺在保持核心框架不变的基础上，对薄弱位置进行了针对性补强。球队的反击速度和效率是最大武器，但面对密集防守时的破局能力仍需提升。</p>
      
      <p>综合来看，新赛季的英超竞争将更加激烈，六支球队各有优势也各有短板。谁能在漫长的38轮较量中保持稳定性，谁就更有可能在明年五月捧起冠军奖杯。</p>
    `,
    tags: ['英超', '赛季前瞻', '豪门分析', '转会市场'],
    relatedArticles: ['article-2', 'article-5'],
  },
  {
    id: 'article-2',
    title: 'NBA休赛期交易大盘点：三支球队的操作被评为A+级',
    slug: 'nba-offseason-trades-review-2026',
    category: 'basketball',
    author: '李明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20sports%20analyst%20portrait%20in%20clean%20studio%20with%20neutral%20background%2C%20editorial%20photography%2C%20warm%20professional%20look&width=100&height=100&seq=avatar-liming&orientation=squarish',
    date: '2026-08-06',
    readTime: '6分钟',
    views: 32100,
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20court%20with%20dramatic%20arena%20lighting%2C%20NBA%20game%20atmosphere%2C%20players%20in%20action%20on%20hardwood%20floor%2C%20packed%20arena%20with%20excited%20fans%2C%20sports%20photography%2C%20cinematic%20warm%20tones&width=800&height=450&seq=article-basketball-1&orientation=landscape',
    excerpt: 'NBA休赛期的交易市场已经接近尾声，各支球队的运作成果也逐渐明朗。我们从阵容补强、薪资灵活性和未来潜力三个角度，评选出三支操作最出色的球队。',
    content: `
      <p>NBA休赛期的交易市场已经接近尾声，各支球队的运作成果也逐渐明朗。我们从阵容补强、薪资灵活性和未来潜力三个角度，评选出三支操作最出色的球队。</p>
      
      <h3>雷霆：未来资产最丰厚</h3>
      <p>雷霆管理层在这个休赛期再次展现了他们的长远眼光。通过精准的交易操作，球队不仅补强了薄弱的内线位置，更积累了未来多个首轮选秀权。年轻核心阵容的成长加上充裕的薪资空间，让雷霆在未来3-5年内都保持着极强的竞争力。</p>
      
      <h3>凯尔特人：卫冕冠军的精准补强</h3>
      <p>作为上赛季的总冠军，凯尔特人在休赛期并没有进行大规模调整，而是针对性地补强了板凳深度。几名经验丰富的老将以底薪加盟，为球队的轮换阵容增添了厚度。这种精准的小修小补恰恰体现了卫冕冠军的成熟与自信。</p>
      
      <h3>马刺：重建计划稳步推进</h3>
      <p>马刺在选秀和自由市场上的操作让人眼前一亮。围绕年轻核心打造的阵容框架已经初具雏形，新引进的几位实力派球员完美契合球队的战术体系。虽然短期内还难以冲击季后赛，但球队的重建方向非常清晰。</p>
      
      <p>当然，休赛期的操作只是成功的一半，球队在新赛季的实际表现才是最终的检验标准。但至少从纸面上看，这些球队已经为即将到来的新赛季做好了充分准备。</p>
    `,
    tags: ['NBA', '休赛期', '交易分析', '球队评级'],
    relatedArticles: ['article-1', 'article-7'],
  },
  {
    id: 'article-3',
    title: '美网开赛在即：五大看点提前解读，中国选手能否再创历史？',
    slug: 'us-open-preview-2026',
    category: 'tennis',
    author: '王芳',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20sports%20journalist%20portrait%20in%20clean%20studio%20lighting%2C%20neutral%20background%2C%20editorial%20style%2C%20warm%20professional%20look&width=100&height=100&seq=avatar-wangfang&orientation=squarish',
    date: '2026-08-05',
    readTime: '7分钟',
    views: 19800,
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20at%20sunset%20with%20dramatic%20lighting%2C%20hard%20court%20surface%2C%20tennis%20racket%20and%20balls%2C%20grand%20slam%20atmosphere%2C%20stadium%20with%20blue%20court%2C%20sports%20photography%2C%20cinematic%20composition&width=800&height=450&seq=article-tennis-1&orientation=landscape',
    excerpt: '2026年美国网球公开赛即将在纽约法拉盛公园打响。作为年度最后一项大满贯赛事，美网承载着无数球员的赛季梦想。本文为您梳理五大看点，包括中国选手的晋级前景。',
    content: `
      <p>2026年美国网球公开赛即将在纽约法拉盛公园打响。作为年度最后一项大满贯赛事，美网承载着无数球员的赛季梦想。本文为您梳理五大看点。</p>
      
      <h3>看点一：男单冠军之争——新老交替的关键一战</h3>
      <p>本赛季男子网坛的竞争格局发生了微妙变化。新生代球员在大满贯赛事中屡创佳绩，而老将们的状态依然保持在高水平。美网作为硬地赛事的巅峰之战，将直接决定年终世界第一的归属。</p>
      
      <h3>看点二：女单赛场——百花齐放</h3>
      <p>女子网坛的竞争从未如此激烈。本赛季已经诞生了多位新科大满贯冠军，没有一位选手展现出绝对的统治力。美网的快速硬地球场将为进攻型选手提供天然优势。</p>
      
      <h3>看点三：中国选手的突破机遇</h3>
      <p>中国网球近年来进步显著，多位选手在世界排名中稳步上升。本届美网，中国选手在男女单打和双打项目中均有参赛，其中几位种子选手有望创造个人美网最佳战绩。年轻一代选手的崛起让中国网球的未来充满期待。</p>
      
      <h3>看点四：夜场比赛的魅力</h3>
      <p>美网的夜场比赛向来是赛事的一大特色。阿瑟·阿什球场的灯光下，无数经典对决被铭刻在网球史册中。今年的夜场赛程同样值得期待。</p>
      
      <h3>看点五：奖金再创新高</h3>
      <p>美网组委会宣布本届赛事总奖金将再创历史新高，首轮出局选手的奖金也大幅提升。这体现了大满贯赛事对每一位参赛球员的尊重与支持。</p>
    `,
    tags: ['美网', '大满贯', '中国网球', '赛事前瞻'],
    relatedArticles: ['article-8', 'article-12'],
  },
  {
    id: 'article-4',
    title: '英雄联盟全球总决赛S16：LPL赛区四支代表队实力全面解析',
    slug: 'lol-worlds-s16-lpl-teams-analysis',
    category: 'esports',
    author: '刘洋',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20Asian%20male%20esports%20journalist%20portrait%20in%20clean%20studio%2C%20neutral%20background%2C%20editorial%20style%2C%20modern%20casual%20look&width=100&height=100&seq=avatar-liuyang&orientation=squarish',
    date: '2026-08-07',
    readTime: '10分钟',
    views: 45200,
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20massive%20LED%20screens%20and%20dramatic%20stage%20lighting%2C%20gaming%20tournament%20atmosphere%2C%20packed%20arena%20with%20fans%2C%20cyberpunk%20aesthetic%20with%20blue%20and%20red%20accents%2C%20cinematic%20wide%20shot&width=800&height=450&seq=article-esports-1&orientation=landscape',
    excerpt: '随着LPL夏季赛落下帷幕，四支代表中国赛区出征S16全球总决赛的队伍已经确定。本文将从战队风格、核心选手和战术体系三个维度，为您全面解析LPL军团的实力。',
    content: `
      <p>随着LPL夏季赛落下帷幕，四支代表中国赛区出征S16全球总决赛的队伍已经确定。本文将从战队风格、核心选手和战术体系三个维度，为您全面解析LPL军团的实力。</p>
      
      <h3>一号种子：夏季赛冠军的统治力</h3>
      <p>作为LPL夏季赛冠军，一号种子在季后赛中展现出了令人窒息的统治力。战队的中野组合堪称世界顶级，上单选手在本赛季完成了质的飞跃。战队的战术体系围绕快速节奏和资源控制展开，这在当前版本中具有极大的优势。</p>
      
      <h3>二号种子：老牌强队的底蕴</h3>
      <p>二号种子的丰富大赛经验是他们的最大武器。战队的下路双人组配合默契，在团战中的输出能力属于世界一流水平。虽然常规赛偶有起伏，但季后赛中的调整能力让人印象深刻。</p>
      
      <h3>三号种子：新生力量的崛起</h3>
      <p>三号种子是本赛季最大的黑马。一群年轻选手在没有任何超级巨星的情况下，依靠出色的团队协作和战术执行力杀入世界赛。他们的打法灵活多变，往往让对手难以针对性准备。</p>
      
      <h3>四号种子：冒泡赛的逆袭传奇</h3>
      <p>从冒泡赛一路杀出的四号种子，用实力证明了他们的韧性。战队在劣势局面下的翻盘能力令人惊叹，打野选手的个人能力更是达到了巅峰状态。如果能在世界赛保持这种势头，他们完全有能力走得更远。</p>
      
      <p>LPL赛区近年来在全球总决赛中的表现有目共睹，四支队伍各有特色。期待他们在世界舞台上再次展现中国电竞的实力。</p>
    `,
    tags: ['英雄联盟', 'S16', 'LPL', '全球总决赛', '电竞'],
    relatedArticles: ['article-9', 'article-3'],
  },
  {
    id: 'article-5',
    title: '欧冠小组赛抽签结果揭晓：死亡之组再现，豪门对决提前上演',
    slug: 'champions-league-group-stage-draw-2026',
    category: 'football',
    author: '张伟',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20sports%20journalist%20portrait%20in%20clean%20studio%20lighting%20with%20neutral%20gray%20background%2C%20editorial%20style%2C%20warm%20professional%20look%2C%20Asian%20male%20in%20casual%20blazer&width=100&height=100&seq=avatar-zhangwei&orientation=squarish',
    date: '2026-08-04',
    readTime: '5分钟',
    views: 24300,
    image: 'https://readdy.ai/api/search-image?query=UEFA%20Champions%20League%20draw%20ceremony%20with%20elegant%20stage%20and%20golden%20lighting%2C%20football%20trophy%20displayed%2C%20soccer%20balls%20with%20Champions%20League%20star%20design%2C%20premium%20event%20atmosphere%2C%20professional%20photography&width=800&height=450&seq=article-football-2&orientation=landscape',
    excerpt: '2026-2027赛季欧冠小组赛抽签仪式在摩纳哥举行，32支球队各归其位。本次抽签再次诞生了令人期待的死亡之组，多支豪门将在小组赛阶段就展开激烈厮杀。',
    content: `
      <p>2026-2027赛季欧冠小组赛抽签仪式在摩纳哥蒙特卡洛举行，32支球队各归其位。本次抽签再次诞生了令人期待的死亡之组，多支豪门将在小组赛阶段就展开激烈厮杀。</p>
      
      <h3>死亡之组：三强鼎立</h3>
      <p>B组无疑是本届欧冠最具看点的小组。上赛季的欧冠四强中有两支球队被分在同一小组，加上一支实力强劲的德甲劲旅，三支球队都有出线的实力。每一轮比赛都可能改变小组出线形势。</p>
      
      <h3>卫冕冠军的签运</h3>
      <p>卫冕冠军抽到了一个相对友好的小组。虽然同组的对手各有特点，但整体实力差距较为明显。球队可以将更多精力放在联赛中，为淘汰赛阶段积蓄力量。</p>
      
      <h3>黑马之组</h3>
      <p>D组的四支球队实力相对均衡，没有任何一支球队有绝对的出线把握。这种实力接近的分组往往容易诞生黑马，任何一支球队都有可能成为搅局者。</p>
      
      <h3>中国球员的欧冠之旅</h3>
      <p>本赛季共有两位中国球员所在的俱乐部进入欧冠正赛。他们能否在欧冠赛场上获得稳定的出场时间，将是中国球迷最为关注的焦点之一。</p>
      
      <p>小组赛首轮将于9月中旬打响，让我们一起期待这场欧洲足球盛宴的开启。</p>
    `,
    tags: ['欧冠', '小组赛', '抽签', '死亡之组'],
    relatedArticles: ['article-1', 'article-3'],
  },
  {
    id: 'article-6',
    title: 'CBA新赛季改革方案出炉：外援政策大调整，年轻球员迎来新机遇',
    slug: 'cba-new-season-reform-2026',
    category: 'basketball',
    author: '赵强',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20male%20basketball%20journalist%20portrait%20in%20clean%20studio%20with%20neutral%20background%2C%20editorial%20style%2C%20warm%20professional%20look&width=100&height=100&seq=avatar-zhaoqiang&orientation=squarish',
    date: '2026-08-03',
    readTime: '6分钟',
    views: 18700,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20basketball%20arena%20with%20dramatic%20game%20action%2C%20CBA%20league%20atmosphere%2C%20players%20dunking%20on%20court%2C%20packed%20indoor%20stadium%20with%20Chinese%20fans%2C%20professional%20sports%20photography%2C%20warm%20lighting&width=800&height=450&seq=article-basketball-2&orientation=landscape',
    excerpt: 'CBA联赛官方正式公布了2026-2027赛季的多项改革措施，其中最引人关注的是外援使用政策的重大调整。新规将为本土年轻球员提供更多的出场机会和发展空间。',
    content: `
      <p>CBA联赛官方正式公布了2026-2027赛季的多项改革措施，其中最引人关注的是外援使用政策的重大调整。新规将为本土年轻球员提供更多的出场机会和发展空间。</p>
      
      <h3>外援政策调整的核心内容</h3>
      <p>新赛季外援上场时间将受到更严格的限制，每场比赛外援总上场时间将从之前的四节六人次调整为四节四人次。这一调整直接减少了外援在比赛中的影响力，迫使各支球队更多地依赖本土球员。</p>
      
      <h3>年轻球员的新机遇</h3>
      <p>新规同时规定，每场比赛至少要有两名23岁以下的球员进入12人大名单，并且至少有一人获得不少于10分钟的上场时间。这为年轻球员的成长提供了制度性保障，有望加速中国篮球人才梯队的建设。</p>
      
      <h3>俱乐部反应不一</h3>
      <p>对于新规，各俱乐部的反应存在明显分歧。财力雄厚的俱乐部认为外援限制会影响联赛观赏性，而以培养年轻球员见长的俱乐部则对这一政策表示支持。如何在竞技水平和人才培养之间找到平衡，将考验管理层的智慧。</p>
      
      <h3>对国家队建设的意义</h3>
      <p>从长远来看，外援限制政策与国家队建设密切相关。给予本土球员更多高质量比赛时间，将有助于提升中国篮球的整体水平。新赛季的CBA改革无疑是中国篮球发展的一个重要转折点。</p>
    `,
    tags: ['CBA', '外援政策', '改革', '年轻球员', '中国篮球'],
    relatedArticles: ['article-2', 'article-10'],
  },
  {
    id: 'article-7',
    title: 'DOTA2国际邀请赛Ti16：奖金池再创新高，中国战队能否夺回荣耀？',
    slug: 'dota2-ti16-preview-2026',
    category: 'esports',
    author: '刘洋',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20Asian%20male%20esports%20journalist%20portrait%20in%20clean%20studio%2C%20neutral%20background%2C%20editorial%20style%2C%20modern%20casual%20look&width=100&height=100&seq=avatar-liuyang&orientation=squarish',
    date: '2026-08-02',
    readTime: '8分钟',
    views: 35600,
    image: 'https://readdy.ai/api/search-image?query=Massive%20esports%20arena%20with%20DOTA2%20tournament%20stage%2C%20five%20gaming%20stations%20with%20players%2C%20huge%20LED%20screens%20showing%20game%20action%2C%20dramatic%20purple%20and%20gold%20lighting%2C%20packed%20audience%2C%20grand%20scale%20event&width=800&height=450&seq=article-esports-2&orientation=landscape',
    excerpt: 'DOTA2年度盛事——第十六届国际邀请赛（Ti16）即将在哥本哈根拉开帷幕。本届赛事奖金池再次刷新纪录，中国赛区三支代表队蓄势待发，力争夺回阔别多年的冠军神盾。',
    content: `
      <p>DOTA2年度盛事——第十六届国际邀请赛（Ti16）即将在哥本哈根拉开帷幕。本届赛事奖金池再次刷新纪录，中国赛区三支代表队蓄势待发，力争夺回阔别多年的冠军神盾。</p>
      
      <h3>奖金池再创纪录</h3>
      <p>Ti16的基础奖金池已经突破4000万美元，加上互动指南的持续贡献，总奖金有望突破5000万美元大关。冠军队伍将获得超过2000万美元的奖金，这是电子竞技历史上最高的单项赛事奖金。</p>
      
      <h3>中国战队：三箭齐发</h3>
      <p>本届Ti16，中国赛区共有三支队伍获得参赛资格。一号种子在DPC赛季中表现稳定，战术体系成熟；二号种子擅长后期团战，拥有顶级的Carry选手；三号种子则是本赛季最大的惊喜，年轻的阵容充满了不可预测性。</p>
      
      <h3>主要对手分析</h3>
      <p>西欧赛区的队伍依然是夺冠热门，他们在版本理解和战术创新方面保持领先。东南亚赛区的崛起也不容忽视，他们的比赛风格极具侵略性。中国战队需要在保持自身特色的同时，适应国际赛场的对抗强度。</p>
      
      <h3>版本变化带来的影响</h3>
      <p>Ti16将使用全新的7.35版本，这对于所有参赛队伍来说都是公平的起点。谁能更快地适应新版本，谁就能在比赛中占据先机。中国战队的战术灵活性和调整能力将受到严峻考验。</p>
    `,
    tags: ['DOTA2', 'Ti16', '国际邀请赛', '电竞', '中国战队'],
    relatedArticles: ['article-4', 'article-6'],
  },
  {
    id: 'article-8',
    title: '世界田径锦标赛综述：多项世界纪录被打破，中国短跑再创佳绩',
    slug: 'world-athletics-championships-review-2026',
    category: 'comprehensive',
    author: '陈静',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20sports%20reporter%20portrait%20in%20clean%20studio%20with%20neutral%20background%2C%20editorial%20style%2C%20warm%20professional%20look&width=100&height=100&seq=avatar-chenjing&orientation=squarish',
    date: '2026-08-01',
    readTime: '9分钟',
    views: 22100,
    image: 'https://readdy.ai/api/search-image?query=Professional%20athletics%20track%20and%20field%20stadium%20with%20runners%20sprinting%20at%20finish%20line%2C%20dramatic%20evening%20lighting%2C%20Olympic%20style%20venue%2C%20packed%20stadium%2C%20world%20championship%20atmosphere%2C%20sports%20photography&width=800&height=450&seq=article-athletics-1&orientation=landscape',
    excerpt: '2026年世界田径锦标赛在布达佩斯圆满落幕。本届世锦赛共诞生了5项新的世界纪录，中国田径队取得了2金3银2铜的优异成绩，创造了参加世锦赛以来的最佳战绩。',
    content: `
      <p>2026年世界田径锦标赛在布达佩斯圆满落幕。本届世锦赛共诞生了5项新的世界纪录，中国田径队取得了2金3银2铜的优异成绩，创造了参加世锦赛以来的最佳战绩。</p>
      
      <h3>新世界纪录的诞生</h3>
      <p>本届世锦赛见证了5项世界纪录的刷新，涉及男子撑杆跳高、女子400米栏、男子铅球、女子三级跳远和男女混合4x400米接力。科技的进步和训练方法的革新正在不断推动人类运动极限的突破。</p>
      
      <h3>中国短跑的突破</h3>
      <p>中国短跑在本届世锦赛中表现惊艳。男子4x100米接力队以刷新亚洲纪录的成绩夺得银牌，女子100米选手首次闯入世锦赛决赛并取得第五名的好成绩。中国短跑正在向世界一流水平稳步迈进。</p>
      
      <h3>田赛项目的稳定输出</h3>
      <p>女子铅球和女子标枪项目继续保持着世界领先水平，再次为中国队贡献了两枚金牌。老将的稳定发挥和新人的崭露头角，让中国田径的田赛优势得以延续。</p>
      
      <h3>年轻选手的成长</h3>
      <p>本届世锦赛上，多位中国年轻选手完成了自己的世界大赛首秀。虽然没有取得奖牌，但他们的表现已经展现出了巨大的潜力。这些年轻面孔将成为中国田径未来的中坚力量。</p>
    `,
    tags: ['田径', '世锦赛', '世界纪录', '中国短跑', '综合体育'],
    relatedArticles: ['article-3', 'article-11'],
  },
  {
    id: 'article-9',
    title: '王者荣耀世界冠军杯：AG超玩会与狼队的巅峰对决深度复盘',
    slug: 'honor-of-kings-world-cup-final-review',
    category: 'esports',
    author: '刘洋',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20young%20Asian%20male%20esports%20journalist%20portrait%20in%20clean%20studio%2C%20neutral%20background%2C%20editorial%20style%2C%20modern%20casual%20look&width=100&height=100&seq=avatar-liuyang&orientation=squarish',
    date: '2026-07-30',
    readTime: '12分钟',
    views: 52300,
    image: 'https://readdy.ai/api/search-image?query=Massive%20mobile%20esports%20arena%20with%20Honor%20of%20Kings%20tournament%20stage%2C%20players%20competing%20on%20mobile%20devices%2C%20huge%20screens%20displaying%20game%20action%2C%20dramatic%20red%20and%20gold%20lighting%2C%20packed%20Chinese%20audience%2C%20grand%20final%20atmosphere&width=800&height=450&seq=article-esports-3&orientation=landscape',
    excerpt: '王者荣耀世界冠军杯总决赛在深圳大运中心体育馆落下帷幕，AG超玩会与狼队上演了一场足以载入电竞史册的七局大战。本文将从BP策略、关键团战和选手表现三个角度进行深度复盘。',
    content: `
      <p>王者荣耀世界冠军杯总决赛在深圳大运中心体育馆落下帷幕，AG超玩会与狼队上演了一场足以载入电竞史册的七局大战。本文将从BP策略、关键团战和选手表现三个角度进行深度复盘。</p>
      
      <h3>BP博弈：巅峰对决的战术预演</h3>
      <p>七局比赛的BP阶段堪称经典。双方教练组在英雄选择和阵容搭配上展开了激烈的心理博弈。关键的第四局，AG超玩会出人意料地放出了版本强势英雄，这一决策直接改变了后续三局比赛的走向。</p>
      
      <h3>第五局：整场决赛的转折点</h3>
      <p>第五局的比赛是整个BO7的转折点。AG超玩会在落后两局的情况下，通过中期的两次完美团战扭转了局势。打野选手在龙坑附近的果断开团，展现了顶级选手的大心脏和决断力。</p>
      
      <h3>决胜局：荣耀与遗憾</h3>
      <p>第七局决胜局，双方都拿出了各自的招牌阵容。比赛的悬念一直保持到了最后时刻，一波高地前的5v5团战决定了冠军的归属。AG超玩会在决策上的微小失误被狼队精准抓住，最终遗憾落败。</p>
      
      <h3>FMVP选手的封神之战</h3>
      <p>狼队的核心选手在总决赛中打出了职业生涯的最佳表现，七局比赛使用了五个不同的英雄，每一局都发挥了关键作用。FMVP的荣誉实至名归。</p>
    `,
    tags: ['王者荣耀', '世界冠军杯', 'AG超玩会', '狼队', '电竞'],
    relatedArticles: ['article-4', 'article-7'],
  },
  {
    id: 'article-10',
    title: 'F1匈牙利站：雨战上演惊天逆转，中国车手首次登上领奖台',
    slug: 'f1-hungarian-gp-2026-review',
    category: 'comprehensive',
    author: '陈静',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20sports%20reporter%20portrait%20in%20clean%20studio%20with%20neutral%20background%2C%20editorial%20style%2C%20warm%20professional%20look&width=100&height=100&seq=avatar-chenjing&orientation=squarish',
    date: '2026-07-28',
    readTime: '7分钟',
    views: 27500,
    image: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20speeding%20on%20wet%20racetrack%20with%20dramatic%20rain%20spray%2C%20racing%20circuit%20atmosphere%2C%20grandstand%20with%20fans%2C%20professional%20motorsport%20photography%2C%20cinematic%20action%20shot%2C%20moody%20sky&width=800&height=450&seq=article-f1-1&orientation=landscape',
    excerpt: 'F1匈牙利大奖赛在布达佩斯亨格罗林赛道精彩落幕。一场突如其来的大雨彻底改变了比赛走势，多位车手在复杂的天气条件下上演了精彩的超车好戏。中国车手历史性地登上了领奖台。',
    content: `
      <p>F1匈牙利大奖赛在布达佩斯亨格罗林赛道精彩落幕。一场突如其来的大雨彻底改变了比赛走势，多位车手在复杂的天气条件下上演了精彩的超车好戏。</p>
      
      <h3>天气：最大的变数</h3>
      <p>比赛开始前，天气预报显示有60%的降雨概率，这让各支车队在轮胎策略上陷入了两难。第15圈，大雨如期而至，赛道瞬间变成了一条湿滑的河流。多位车手在进站换胎的时机选择上出现了分歧，这直接导致了后续排名的剧烈变化。</p>
      
      <h3>中国车手的里程碑时刻</h3>
      <p>本场比赛的最大亮点来自中国车手。他从第8位发车，在雨中展现了出色的控车能力和战术执行力。通过精准的进站时机选择和多次精彩的超车，他最终以第三名的成绩冲过终点线，成为F1历史上首位登上领奖台的中国车手。</p>
      
      <h3>冠军争夺的转折</h3>
      <p>积分榜领先者在雨中遭遇了轮胎策略失误，最终仅获得第七名。这让车手总冠军的争夺重新变得充满悬念。而本站夺冠的车手则将与领先者的积分差距缩小到了15分。</p>
      
      <h3>赛后的反应</h3>
      <p>中国车手登上领奖台的消息迅速点燃了社交媒体。这不仅是中国赛车运动的历史性突破，更证明了亚洲车手在世界顶级赛车运动中的竞争力。</p>
    `,
    tags: ['F1', '匈牙利站', '雨战', '中国车手', '领奖台'],
    relatedArticles: ['article-8', 'article-6'],
  },
  {
    id: 'article-11',
    title: '乒乓球世界杯：国乒包揽五项冠军，新生代选手崭露头角',
    slug: 'table-tennis-world-cup-2026',
    category: 'comprehensive',
    author: '王芳',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20sports%20journalist%20portrait%20in%20clean%20studio%20lighting%2C%20neutral%20background%2C%20editorial%20style%2C%20warm%20professional%20look&width=100&height=100&seq=avatar-wangfang&orientation=squarish',
    date: '2026-07-25',
    readTime: '5分钟',
    views: 16300,
    image: 'https://readdy.ai/api/search-image?query=Professional%20table%20tennis%20competition%20with%20player%20serving%20in%20dramatic%20lighting%2C%20indoor%20sports%20arena%2C%20ping%20pong%20action%20shot%2C%20Chinese%20national%20team%20atmosphere%2C%20fast%20motion%2C%20sports%20photography&width=800&height=450&seq=article-tabletennis-1&orientation=landscape',
    excerpt: '2026年乒乓球世界杯在成都圆满收官。中国乒乓球队再次展现了无可撼动的统治力，包揽了男单、女单、男双、女双和混双全部五个项目的冠军。',
    content: `
      <p>2026年乒乓球世界杯在成都圆满收官。中国乒乓球队再次展现了无可撼动的统治力，包揽了男单、女单、男双、女双和混双全部五个项目的冠军。</p>
      
      <h3>男单：新老交替的标志性胜利</h3>
      <p>男单决赛在两位中国选手之间展开。最终，22岁的新星以4-2击败了经验丰富的老将，首次夺得世界杯男单冠军。这标志着中国男乒新老交替的正式完成。</p>
      
      <h3>女单：统治力的延续</h3>
      <p>中国女乒的优势依然不可撼动。世界排名第一的选手在决赛中以4-0横扫对手，整届赛事未失一局。她的技术全面性和心理素质让所有对手望尘莫及。</p>
      
      <h3>双打项目：默契致胜</h3>
      <p>男双和女双的金牌同样被中国组合收入囊中。长期配合带来的默契是中国双打的最大优势。混双项目上，一对新组合出人意料地夺得了金牌，展现了中国乒乓球的深厚人才储备。</p>
      
      <h3>展望巴黎奥运周期</h3>
      <p>本次世界杯是中国乒乓球队在巴黎奥运会前的重要练兵。新人的崛起让教练组在奥运阵容的选择上有了更多选项。中国乒乓球的统治地位在可预见的未来仍将延续。</p>
    `,
    tags: ['乒乓球', '世界杯', '国乒', '冠军', '综合体育'],
    relatedArticles: ['article-8', 'article-3'],
  },
  {
    id: 'article-12',
    title: '温网卫冕之路：草地之王的统治力还能持续多久？',
    slug: 'wimbledon-dominance-analysis-2026',
    category: 'tennis',
    author: '王芳',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20female%20sports%20journalist%20portrait%20in%20clean%20studio%20lighting%2C%20neutral%20background%2C%20editorial%20style%2C%20warm%20professional%20look&width=100&height=100&seq=avatar-wangfang&orientation=squarish',
    date: '2026-07-20',
    readTime: '6分钟',
    views: 14200,
    image: 'https://readdy.ai/api/search-image?query=Wimbledon%20tennis%20court%20with%20green%20grass%20and%20white%20uniform%20players%2C%20elegant%20tennis%20atmosphere%2C%20Centre%20Court%20with%20packed%20crowd%2C%20traditional%20British%20sports%20event%2C%20summer%20afternoon%20lighting%2C%20premium%20photography&width=800&height=450&seq=article-tennis-2&orientation=landscape',
    excerpt: '2026年温布尔登网球锦标赛落下帷幕。某位巨星完成了温网五连冠的伟业，在草地赛场的统治力达到了历史级别。但随着他年龄的增长，挑战者们也在不断进步，这种统治还能持续多久？',
    content: `
      <p>2026年温布尔登网球锦标赛落下帷幕。一位巨星完成了温网五连冠的伟业，在草地赛场的统治力达到了历史级别。但随着他年龄的增长，挑战者们也在不断进步，这种统治还能持续多久？</p>
      
      <h3>五连冠的含金量</h3>
      <p>在公开赛年代，能够在温网完成五连冠的球员屈指可数。这不仅需要绝对的技术实力，还需要极强的身体素质和心理承受能力。五连冠的每一座奖杯都代表了不同的挑战和突破。</p>
      
      <h3>草地打法的进化</h3>
      <p>他的草地打法在过去五年间不断进化。从最初依赖大力发球和底线重炮，到如今融入了更多的网前技术和战术变化。这种持续进化的能力正是他能够保持统治力的关键。</p>
      
      <h3>挑战者的崛起</h3>
      <p>新生代球员在草地上的表现正在稳步提升。几位年轻选手在本届温网中展现出了强大的竞争力，他们的打法更加全面，体能储备也更加充沛。虽然目前还难以撼动王座，但差距正在缩小。</p>
      
      <h3>时间是最公平的对手</h3>
      <p>对于任何一位伟大的运动员来说，年龄都是无法回避的挑战。在享受他带来的精彩网球的同时，球迷们也意识到，这段传奇的时光不会永远持续。但至少在2026年的这个夏天，草地之王依然坐在他的王座之上。</p>
    `,
    tags: ['温网', '网球', '五连冠', '草地之王', '大满贯'],
    relatedArticles: ['article-3', 'article-1'],
  },
];

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getArticleBySlug = (slug: string) => {
  return articles.find((article) => article.slug === slug);
};

export const getRelatedArticles = (articleIds: string[]) => {
  return articles.filter((article) => articleIds.includes(article.id));
};

export const getFeaturedArticles = (count: number = 6) => {
  return [...articles].sort((a, b) => b.views - a.views).slice(0, count);
};

export const getLatestArticles = (count: number = 6) => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);
};